export const FREE_DELIVERY_FROM_PRICE = 49.99;
export const SEND_COST = 2.95;
export const CURRENCY = "€ ";
export const DELIVERY_OPTIONS = {
  PICKUP: "pickup",
  SEND: "send",
};

export const PAYMENT_METHODS = {
  CREDITCARD: "creditcard",
  IDEAL: "ideal",
  BANCONTACT: "bancontact",
};

export const ADDRESS_TYPES = {
  DELIVERY: "DELIVERY",
  INVOICE: "INVOICE",
};

export const DELIVERY_DURATION = 2;
export const DELIVERY_DATE_WARNING_DAYS = 28;

export const ZIPCODES_REGIONAL = [
  1600, 1601, 1602, 1610, 1611, 1613, 1614, 1606, 1616, 1607, 1617, 1608, 1696, 1609, 1697, 1620, 1624, 1689, 1621,
  1625, 1695, 1622, 1627, 1623, 1628, 1631, 1642, 1648, 1633, 1643, 1652, 1634, 1711, 1641, 1647, 1713, 1619, 1658,
  1676, 1682, 1686, 1692, 1654, 1670, 1678, 1683, 1687, 1693, 1655, 1671, 1679, 1684, 1688, 1657, 1674, 1681, 1685,
  1691, 1661, 1716, 1662, 1718, 1663, 1719, 1715,
];
